import type { ApiError } from "../api/http";

/**
 * Map a login failure to an i18n key. Backend `detail` strings are English
 * and must never be shown directly — the status code is the contract:
 * 401 invalid credentials, 403 unverified account, 429 throttled (10/min).
 */
export function loginErrorKey(err: ApiError): string {
  switch (err.status) {
    case 429:
      return "auth.login.tooManyAttempts";
    case 403:
      return "auth.login.notVerified";
    case 401:
      return "auth.login.invalidCredentials";
    default:
      return "auth.login.genericError";
  }
}
